import { Box, Card, Stack, Typography, useTheme } from "@mui/material";
import { delftBlue } from "@/theme/colors";

const KPICard = ({ title, value, change, changeType, icon: Icon }) => {
  const theme = useTheme();

  const getChangeColor = () => {
    if (changeType === "positive") return theme.palette.success.main;
    if (changeType === "negative") return theme.palette.error.main;
    return delftBlue[500];
  };

  const getChangeBg = () => {
    if (changeType === "positive") return theme.palette.success.main;
    if (changeType === "negative") return theme.palette.error.main;
    return delftBlue[500];
  };

  return (
    <Card
      sx={{
        flex: "1 1 0",
        minWidth: 0,
        width: "100%",
        paddingTop: { xs: 0.75, sm: 1 },
        paddingBottom: { xs: 0.75, sm: 1 },
        background: "white",
        borderRadius: 2,
        outline: `1px ${delftBlue[100]} solid`,
        outlineOffset: "-1px",
        display: "flex",
        flexDirection: "column",
        overflow: "visible",
        position: "relative",
      }}
    >
      <Box
        sx={{
          alignSelf: "stretch",
          paddingLeft: { xs: 2, sm: 2.5, md: 3 },
          paddingRight: { xs: 2, sm: 2.5, md: 3 },
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: { xs: 40, sm: 44 },
        }}
      >
        <Typography
          sx={{
            color: delftBlue[500],
            fontSize: { xs: 14, sm: 15, md: 16 },
            fontFamily: "Audiowide, sans-serif",
            fontWeight: 400,
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "ellipsis",
            flex: 1,
            display: "block",
            visibility: "visible",
          }}
        >
          {title || "N/A"}
        </Typography>
        {Icon && (
          <Box
            component="img"
            src={Icon}
            alt={title}
            sx={{
              width: { xs: 18, sm: 20 },
              height: { xs: 18, sm: 20 },
              objectFit: "contain",
              flexShrink: 0,
            }}
          />
        )}
      </Box>

      <Box
        sx={{
          alignSelf: "stretch",
          paddingLeft: { xs: 2, sm: 2.5, md: 3 },
          paddingRight: { xs: 2, sm: 2.5, md: 3 },
          paddingTop: { xs: 0.75, sm: 1 },
          paddingBottom: { xs: 0.75, sm: 1 },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          gap: { xs: 1, sm: 0 },
          minHeight: { xs: 60, sm: 70 },
        }}
      >
        <Stack spacing={0.5} flex="1 1 0" sx={{ width: { xs: "100%", sm: "auto" } }}>
          {change && (
            <Box
              sx={{
                minHeight: { xs: "auto", sm: 21.59 },
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Box
                sx={{
                  paddingLeft: { xs: 0.75, sm: 1 },
                  paddingRight: { xs: 0.75, sm: 1 },
                  paddingTop: { xs: 0.2, sm: 0.25 },
                  paddingBottom: { xs: 0.2, sm: 0.25 },
                  background: getChangeBg(),
                  borderRadius: 0.5,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "white",
                    fontSize: { xs: 10, sm: 11 },
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: 500,
                    lineHeight: 1.45,
                    whiteSpace: "nowrap",
                  }}
                >
                  {change || "N/A"}
                </Typography>
              </Box>
            </Box>
          )}
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 10, sm: 11 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 400,
              lineHeight: 1.45,
            }}
          >
            from last period
          </Typography>
        </Stack>

        <Box
          sx={{
            minHeight: { xs: "auto", sm: 31.99 },
            display: "flex",
            justifyContent: { xs: "flex-start", sm: "flex-end" },
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: delftBlue[500],
              fontSize: { xs: 24, sm: 26, md: 28 },
              fontFamily: "Montserrat, sans-serif",
              fontWeight: 700,
              lineHeight: 1.14,
              whiteSpace: "nowrap",
              overflow: "visible",
            }}
          >
            {value !== undefined && value !== null ? value : "N/A"}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default KPICard;



